/**
 * App's React binding. Mirrors apps/book/src/i18n/useTranslation.tsx so the two
 * surfaces read the same; the implementation is shared/i18n/react.tsx.
 */
import { createTranslation } from "@lura/i18n";
import { i18n } from ".";
import type { Locale, MessageKey } from "./messages";

export const { TranslationProvider, useTranslation } = createTranslation<Locale, MessageKey>(i18n);
